import { graphql } from '@api/generated';

export const phoneNumbersForTenant = graphql(`
  query phoneNumbersForTenant(
    $tenantId: ID!
    $filter: TenantPhoneNumberFilterInput
  ) {
    phoneNumbersForTenant(tenantId: $tenantId, filter: $filter) {
      name
      number
      campaignName
    }
  }
`);
